import { ModalPopup, Stack } from 'components';
import { isAiScribeRecordingStatus } from 'store/aiScribe/aiScribeSlice';

import style from './expanded.module.scss';
import { useAiScribeContext } from '../../context/useAiScribe';
import IdleScreen from './idleScreen/idleScreen';
import RecordingScreen from './recordingScreen/recordingScreen';
import TranscribingScreen from './transcribingScreen/transcribingScreen';

const Expanded = () => {
  const { state, status, handleDrawerClose } = useAiScribeContext();
  const isRecordingView = isAiScribeRecordingStatus(status);
  const isIdleView = status === 'idle' || status === 'initializing' || status === 'failed';

  const getIconClose = () => {
    if (isRecordingView) return 'remove';
    if (status === 'transcribing' || status === 'transcribed') return 'close';
    return 'close';
  };

  return (
    <ModalPopup
      open={state === 'expanded'}
      customClassInsideContainer={style.modal}
      customClassModalContentContainer={style.contentContainer}
      customClassCloseIconContainer={style.closeIconContainer}
      handleClose={handleDrawerClose}
      iconClose={getIconClose()}
    >
      <Stack height="100%" width="100%">
        {isIdleView && <IdleScreen />}
        {isRecordingView && <RecordingScreen />}
        {(status === 'transcribing' || status === 'transcribed') && <TranscribingScreen />}
      </Stack>
    </ModalPopup>
  );
};

export default Expanded;
